
export const DEFAULT_URL = 'https://api.doxx.care/api/'
// export const DEFAULT_URL = 'https://api-dev.doxx.care/api/'




